(function () {
    angular.module(modules.homeModule, ['ui.bootstrap', 'ui.router']);
})();